import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetTaskSaga() {
    yield put(appActions.TASK_RESET_SUCCESS());
}

function* resetTaskTagSaga() {
    yield put(appActions.TASKTAG_RESET_SUCCESS());
}

function* watchTaskGetAllRequest() {
    yield takeLatest(
        appActions.TASK_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/task',
                appActions.TASK_GET_ALL_SUCCESS,
                appActions.TASK_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchTaskCreateRequest() {
    yield takeLatest(
        appActions.TASK_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/task/save',
                appActions.TASK_CREATE_SUCCESS,
                appActions.TASK_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchTaskCopyRequest() {
    yield takeLatest(
        appActions.TASK_COPY_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `/communication/v1/task/copy/${action?.payload?.taskId}`,
                appActions.TASK_COPY_SUCCESS,
                appActions.TASK_COPY_FAILURE,
            );
        },
    );
}

function* watchTaskDeleteRequest() {
    yield takeLatest(
        appActions.TASK_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                `/communication/v1/task`,
                appActions.TASK_DELETE_SUCCESS,
                appActions.TASK_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchTaskUpdateRequest() {
    yield takeLatest(
        appActions.TASK_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/task/update',
                appActions.TASK_UPDATE_SUCCESS,
                appActions.TASK_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchTaskTagGetAllRequest() {
    yield takeLatest(
        appActions.TASKTAG_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/task/tag',
                appActions.TASKTAG_GET_ALL_SUCCESS,
                appActions.TASKTAG_GET_ALL_FAILURE,
            );
        },
    );
}


function* watchTaskTagCreateRequest() {
    yield takeLatest(
        appActions.TASKTAG_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/task/tag/save',
                appActions.TASKTAG_CREATE_SUCCESS,
                appActions.TASKTAG_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

export default function* taskWatcher() {
    yield* watchTaskGetAllRequest();
    yield* watchTaskCreateRequest();
    yield* watchTaskUpdateRequest();
    yield* watchTaskDeleteRequest();
    yield* watchTaskCopyRequest();
    yield takeLatest(appActions.TASK_RESET_REQUEST.type, resetTaskSaga);
    yield* watchTaskTagGetAllRequest();
    yield* watchTaskTagCreateRequest();
    yield takeLatest(appActions.TASKTAG_RESET_REQUEST.type, resetTaskTagSaga);
    // Add other watchers here
}
